
const apiUrl = process.env.REACT_APP_API_URL;
export const GetPlatIngredients = async ( page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/plats/ingredients`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        console.log(jsonData);
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};